import { SVGIcon } from '@data/svg-icons.data';
import { MessageBoxType } from './message-box.types';

/** Icon and Tailwind classes of one message-box variant. */
export interface MessageBoxStyle {
  icon: SVGIcon;
  background: string;
  border: string;
  /** Colour of the icon — the border's shade. */
  iconText: string;
  text: string;
}

/** Look of every message-box variant, keyed by its `type`. */
export const MESSAGE_BOX_STYLES: Record<MessageBoxType, MessageBoxStyle> = {
  error: {
    icon: 'error-bold',
    background: 'bg-kz-red-50',
    border: 'border-kz-red-600',
    iconText: 'text-kz-red-600',
    text: 'text-kz-red-600'
  },
  warn: {
    icon: 'warn-triangle',
    background: 'bg-kz-yellow-200',
    border: 'border-kz-yellow-800',
    iconText: 'text-kz-yellow-800',
    text: 'text-kz-grey-500'
  },
  success: {
    icon: 'check-circle',
    background: 'bg-kz-green-50',
    border: 'border-kz-green-500',
    iconText: 'text-kz-green-500',
    text: 'text-kz-green-500'
  },
  info: {
    icon: 'info-circle',
    background: 'bg-kz-light-blue-50',
    border: 'border-kz-light-blue-700',
    iconText: 'text-kz-light-blue-700',
    text: 'text-kz-light-blue-700'
  },
  primary: {
    icon: 'chevron_right',
    background: 'bg-kz-orange-50',
    border: 'border-kz-primary',
    iconText: 'text-kz-primary',
    text: 'text-kz-primary'
  }
};

/** How long the "Copied to clipboard" snackbar stays up. */
export const MESSAGE_BOX_COPIED_SNACKBAR_DURATION_MS = 3000;
